import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(utc);
dayjs.extend(updateLocale);

// export const convertUTCtoLocal = (value: string) => {
//   if (value === '-') return '-';
//   return dayjs(new Date(`${dayjs(value, 'DD/MM/YYYY hh:mm:ss').format('MM/DD/YYYY hh:mm:ss')} UTC`)).format(
//     'MMMM DD, YYYY hh:mmA'
//   );
// };

export const convertUTCtoLocal = (utcDateTime: string) => {
  if (!utcDateTime || utcDateTime === '-') return '-';

  const localDateTime = dayjs.utc(utcDateTime, 'DD/MM/YYYY HH:mm:ss').local();

  return localDateTime.format('MMMM DD, YYYY hh:mmA');
};

export const getGraphLabels = (timeline: string, labels: any = []) => {
  switch (timeline) {
    case 'daily':
      return labels.map((date: string) => dayjs(date, 'dddd, DD-MM-YY').format('DD-MMM-YYYY'));
    case 'weekly':
      return labels.map((date: string) => {
        const [week, monthYear] = date.split(',');
        return [week, dayjs(monthYear).format('MMM-YYYY')];
      });
    case 'monthly':
      return labels.map((date: string) => dayjs(date).format('MMM, YYYY').split(','));
    default:
      return labels;
  }
};

export const getCurrentTime = () => {
  const currentTime = new Date();
  const currentHour = currentTime.getHours();
  const currentMinute = currentTime.getMinutes();

  const hour = currentHour % 12 === 0 ? 12 : currentHour % 12;
  const minute = currentMinute;
  const period = currentHour < 12 ? 'AM' : 'PM';

  return `${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute} ${period}`;
};

export const dateFormater = (date: any = new Date(), format: string = 'MMM DD, YYYY') => {
  return dayjs(date).format(format);
};